import { useRef, useState } from "react";

import Modal from "shared/Components/modal";
import { MobilePagination } from "shared/Components/mobilePagination";
import { UserDetailCard } from "./UserDetailCard";
import { UserListCard } from "./UserListCard";
import { ROLE } from "helper/utility";
import { globalVariables } from "helper/globalVariables";

export const UserListMobileTable = ({
  users,
  currentPage,
  totalPages,
  loading,
  error,
  handlePageChange,
  onClick,
  handleUpdateRole,
  userRoles,
  editable = true,
}) => {
  const modalRef = useRef();
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);

  const openModal = (e, trialIndex) => {
    e.stopPropagation();
    setSelectedTrialIndex(trialIndex);
    modalRef.current.openModal();
  };

  return (
    <>
      {!error ? (
        <>
          <div className="mb-20">
            {users.length > 0 ? (
              users.map((userDetail, index) => {
                return (
                  <UserListCard
                    key={userDetail?.id}
                    userDetail={{
                      ...userDetail,
                      role:
                        userDetail?.role?.length > 0
                          ? userDetail?.role
                          : [ROLE.Member],
                    }}
                    onViewMoreClick={(e) => openModal(e, index)}
                    onClick={() => onClick?.(userDetail)}
                    handleUpdateRole={handleUpdateRole}
                    userRoles={userRoles}
                    loading={loading}
                    editable={editable}
                  />
                );
              })
            ) : (
              <div className="absolute top-[50%] left-[37%] md:left-[50%]">
                <span className="font-semibold text-xl text-gray-900">
                  {globalVariables.noRecord}
                </span>
              </div>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 ? (
            <MobilePagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          ) : (
            ""
          )}
        </>
      ) : (
        <div className="absolute top-[50%] left-[37%] md:left-[50%]">
          <span className="font-semibold text-xl text-gray-900">
            {error?.message}
          </span>
        </div>
      )}
      <Modal ref={modalRef}>
        {selectedTrialIndex !== null && (
          <UserDetailCard
            userDetail={{
              ...users[selectedTrialIndex],
              role:
                users[selectedTrialIndex]?.role?.length > 0
                  ? users[selectedTrialIndex]?.role
                  : [ROLE.Member],
            }}
            handleUpdateRole={handleUpdateRole}
            userRoles={userRoles}
            loading={loading}
            editable={editable}
          />
        )}
      </Modal>
    </>
  );
};
